import React from 'react';
import c from '../w.js';

const IconPortfolio = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5 4C14.309 4 13.2261 4.46265 12.4212 5.21803C15.5729 5.94622 18.0538 8.4271 18.782 11.5788C19.5373 10.7739 20 9.69096 20 8.5C20 6.01472 17.9853 4 15.5 4ZM18.9863 13.9869C20.7981 12.8334 22 10.807 22 8.5C22 4.91015 19.0898 2 15.5 2C13.193 2 11.1667 3.20191 10.0131 5.01371C5.54522 5.26605 2 8.96901 2 13.5C2 18.1944 5.80558 22 10.5 22C15.031 22 18.7339 18.4548 18.9863 13.9869ZM4 13.5C4 9.91015 6.91015 7 10.5 7C14.0899 7 17 9.91015 17 13.5C17 17.0899 14.0899 20 10.5 20C6.91015 20 4 17.0899 4 13.5Z"
      }
    )
  )
);

export { IconPortfolio };
